import React from 'react';
import ServerLargeListSection from '../components/ServerLargeListSection';

function UsersDashboardPage() {
    return <ServerLargeListSection />;
}

export default UsersDashboardPage;
